module.exports = "<div class=\"NumberSpinner\">{{num}}{{element.data.append}}</div>"


//////////////////
// WEBPACK FOOTER
// ./sgcontenteditor/customElements/numberSpinner.html
// module id = 415
// module chunks = 0